import { createAction } from '@reduxjs/toolkit';

import { ValueOf } from '../../globalTypes';
import { RDC_DEVICE_RESPONSE_STATUS, SESSION_INACTIVE_REASONS } from '../../constants';
import types from './types';

export type RdcAppInstallationResponse = {
  id: string;
  status: ValueOf<typeof RDC_DEVICE_RESPONSE_STATUS>;
  error?: string;
}

const secondsLeftUpdate = createAction<number>(types.RDC_SECONDS_LEFT_UPDATE);
const setSessionClosedReason = createAction<keyof typeof SESSION_INACTIVE_REASONS>(
  types.SET_SESSION_CLOSED_REASON,
);

const pollAppInstallationStatus = async (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  device: Record<string, any>, // aka web-rdc-client
  installationId: string,
  signal: AbortSignal,
): Promise<RdcAppInstallationResponse> => {
  try {
    if (signal.aborted) {
      return {
        id: installationId,
        status: RDC_DEVICE_RESPONSE_STATUS.ABORTED,
      };
    }

    const response = await device.checkAppInstallationStatus(
      installationId,
    ) as RdcAppInstallationResponse;

    if (response.status === RDC_DEVICE_RESPONSE_STATUS.ERROR) {
      throw new Error(response.error);
    }

    if (response.status === RDC_DEVICE_RESPONSE_STATUS.FINISHED) {
      return response;
    }

    return pollAppInstallationStatus(device, installationId, signal);
  } catch (error) {
    return Promise.reject(error);
  }
};

export default {
  pollAppInstallationStatus,
  secondsLeftUpdate,
  setSessionClosedReason,
};
